import ReadyStatusCell from './ready_status_cell';

export default ReadyStatusCell;
